module.exports = __webpack_public_path__ + "static/media/icon1.5ebc933c.svg";